import { IEndpointData } from '@packages/toolbox/dist/declarations/endpoint';
import generateCrudEndpoints from '@packages/toolbox/dist/utils/endpoint-generator';

import { SERVER_API } from 'SharedDir/constants/app/endpoints';

export const routesUrl = `${SERVER_API}/routes`;

export default {
  ROUTES: {
    ...generateCrudEndpoints(routesUrl),
    LIST_BRIEF_TREE(id: number): IEndpointData {
      return {
        method: 'GET',
        url: `${routesUrl}/${id}/tree-brief`,
      };
    },
    VALIDATE(id: number): IEndpointData {
      return {
        method: 'POST',
        url: `${routesUrl}/${id}/validate`,
      };
    },
    COPY(id: number): IEndpointData {
      return {
        method: 'POST',
        url: `${routesUrl}/${id}/copy`,
      };
    },
    PUBLISH(id: number): IEndpointData {
      return {
        method: 'POST',
        url: `${routesUrl}/status/${id}/publish`,
      };
    },
    CHANGE_STATUS(id: number): IEndpointData {
      return {
        method: 'POST',
        url: `${routesUrl}/status/${id}`,
      };
    },
  },
  EXPORT_TEMPLATE: {
    STORE(serviceRouteId: number): IEndpointData {
      return {
        method: 'POST',
        url: `${routesUrl}/${serviceRouteId}/issue-export-template`,
      };
    },
    DELETE(serviceRouteId: number, templateId: number): IEndpointData {
      return {
        method: 'DELETE',
        url: `${routesUrl}/${serviceRouteId}/issue-export-template/${templateId}`,
      };
    },
  },
  STEPS: {
    ...generateCrudEndpoints(`${SERVER_API}/steps`),
    UPDATE_PARAMS(id: number): IEndpointData {
      return {
        method: 'PUT',
        url: `${SERVER_API}/steps/${id}/params`,
      };
    },
    ARRANGE_SECTIONS(id: number): IEndpointData {
      return {
        method: 'PUT',
        url: `${SERVER_API}/steps/${id}/sections/arrange`,
      };
    },
  },
  SECTIONS: {
    ...generateCrudEndpoints(`${SERVER_API}/steps/sections`),
    LINK_PROFILE: {
      GET: {
        method: 'GET',
        url: `${SERVER_API}/steps/sections/fields/link-from-profile`,
      } as IEndpointData,
      STORE: {
        method: 'POST',
        url: `${SERVER_API}/steps/sections/fields/link-from-profile`,
      } as IEndpointData,
      DELETE(id: number): IEndpointData {
        return {
          method: 'DELETE',
          url: `${SERVER_API}/steps/sections/fields/link-from-profile/${id.toString()}`,
        };
      },
    },
  },
};
